import { AssignReviewVideoModal } from './assign-review-promo-video-modal/assign-review-promo-video-modal';
import { DucsModal } from './ducs';
import { ErrorModal } from './error-modal';
import { IdleSessionTimeoutModal } from './idle-session-timeout-modal';
import { NewCoursesVideoModal } from './new-courses-promo-video-modal/new-courses-promo-video-modal';
import { NotificationModal } from './notification-modal';
import { ProfilePictureUpload } from './profile-picture-upload-modal';
import { PromoVideoPopupModal } from './promo-video-popup-modal/variants/assign-review-promo-video/assign-review-promo-video';
import { IntroducingNewCoursesModal } from './promo-video-popup-modal/variants/new-courses-promo-video/new-courses-promo-video';
import { SessionTimeoutModal } from './session-timeout-modal';
import { RefreshedAssignAndReviewModal } from './try-new-course-modal/variants/refreshed-assign-and-review';
import { UserProfileModal } from './user-profile-modal';

export enum ModalVariants {
    error = 'error',
    idleSessionTimeout = 'idleSessionTimeout',
    sessionTimeout = 'sessionTimeout',
    notification = 'notification',
    userProfile = 'userProfile',
    profilePictureUpload = 'profilePictureUpload',
    ducsContent = 'ducsContent',
    promoVideoPopupModal = 'promoVideoPopupModal',
    assignReviewVideoModal = 'assignReviewVideoModal',
    newCoursesVideoModal= 'newCoursesVideoModal',
    introducingNewCoursesModal = 'introducingNewCoursesModal',
    tryRefreshedAssignAndReviewModal = 'tryRefreshedAssignAndReviewModal'
}

export const MODAL_VARIANT_COMPONENTS = {
    [ModalVariants.error]: ErrorModal,
    [ModalVariants.idleSessionTimeout]: IdleSessionTimeoutModal,
    [ModalVariants.sessionTimeout]: SessionTimeoutModal,
    [ModalVariants.notification]: NotificationModal,
    [ModalVariants.userProfile]: UserProfileModal,
    [ModalVariants.profilePictureUpload]: ProfilePictureUpload,
    [ModalVariants.ducsContent]: DucsModal,
    [ModalVariants.promoVideoPopupModal]: PromoVideoPopupModal,
    [ModalVariants.assignReviewVideoModal]: AssignReviewVideoModal,
    [ModalVariants.newCoursesVideoModal]: NewCoursesVideoModal,
    [ModalVariants.introducingNewCoursesModal]: IntroducingNewCoursesModal,
    [ModalVariants.tryRefreshedAssignAndReviewModal]: RefreshedAssignAndReviewModal
};
